import api from './api';

export const discountService = {
  // 1. Employee Authority
  getEmployeeAuthority: async (employeeId) => {
    const res = await api.get(`/discount/authority/employee/${employeeId}`);
    return res.data;
  },

  saveEmployeeAuthority: async (employeeId, payload) => {
    const res = await api.post(`/discount/authority/employee/${employeeId}`, payload);
    return res.data;
  },

  // 2. Server-side Validation
  validateDiscount: async (validationPayload) => {
    const res = await api.post('/discount/validate', validationPayload);
    return res.data;
  },

  // 3. Approval Workflow & Requests
  createApprovalRequest: async (requestPayload) => {
    const res = await api.post('/discount/requests', requestPayload);
    return res.data;
  },

  getPendingApprovals: async (params = {}) => {
    const res = await api.get('/discount/requests/inbox', { params });
    return res.data;
  },

  getApprovalDetail: async (id) => {
    const res = await api.get(`/discount/requests/${id}`);
    return res.data;
  },

  approveRequest: async (id, remarks = '', approvedDiscountAmount = null) => {
    const res = await api.post(`/discount/requests/${id}/approve`, { remarks, approvedDiscountAmount });
    return res.data;
  },

  rejectRequest: async (id, rejectionReason) => {
    const res = await api.post(`/discount/requests/${id}/reject`, { rejectionReason });
    return res.data;
  },

  // 4. Masters & Usage
  getReasons: async (activeOnly = true) => {
    const res = await api.get('/discount/reasons', { params: { activeOnly } });
    return res.data;
  },

  getUsage: async (employeeId, centreId) => {
    const res = await api.get('/discount/usage', { params: { employeeId, centreId } });
    return res.data;
  },
};

export default discountService;
